<template>
  <protected-pages-layout>
    <div class="wrapper" id="team‐report‐wrapper">
      <!-- <navbar></navbar> -->
      <div v-if="!pageReady" class="d-flex justify-content-center align-items-center m-5">
        <div class="spinner-border text-dark" style="width: 7.5rem; height: 7.5rem" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else class="main-content">
        <div class="row" style="margin: 30px 0">
          <div class="col-md-10 offset-md-1">
            <form>
              <div class="row">
                <div class="col">
                  <label>Team</label>
                  <select v-model="parameters.team" class="form-select" @change="getReport()">
                    <option :key="index" :value="team.ID" v-for="(team, index) in teams">
                      {{ team.Name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label>Report Type</label>
                  <select v-model="parameters.teamReportType" class="form-select" @change="getReport()">
                    <option :key="index" :value="reportType.value" v-for="(reportType, index) in teamReportTypes">
                      {{ reportType.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label>Period</label>
                  <select v-model="parameters.period" class="form-select" @change="getReport()">
                    <option :key="index" :value="period.value" v-for="(period, index) in periods">
                      {{ period.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label>Break</label>
                  <select v-model="parameters.breakdown" class="form-select" @change="getReport()">
                    <option :key="index" :value="breakdown.value" v-for="(breakdown, index) in breakdowns">
                      {{ breakdown.name }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col">
                  <div class="card border-0 shadow card-dashboard">
                    <div class="card-body" data-bs-toggle="modal" data-bs-target="#productModal"
                      v-on:click="calculateTotals(); openTotalsModal()">
                      <h6 class="card-subtitle mb-2 text-muted">Total (day)</h6>
                      <h3 class="card-title">{{ totalAsDay }}</h3>
                    </div>
                  </div>
                </div>
                <div class="col" v-if="
                  parameters.teamReportType === 'billable' &&
                  isBillableDataLoaded
                ">
                  <div class="card border-0 shadow card-dashboard">
                    <div class="card-body">
                      <h6 class="card-subtitle mb-2 text-muted">Billed (day)</h6>
                      <h5 class="card-title">
                        Billed: {{ totalManDaysInCampaigns }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="col" v-if="
                    parameters.teamReportType === 'billable' &&
                    isBillableDataLoaded
                  ">
                    <div class="card border-0 shadow card-dashboard">
                      <div class="card-body">
                        <h6 class="card-subtitle mb-2 text-muted">
                          Spent (W/O Offered) (day)
                        </h6>
                        <h5 class="card-title">
                          Spent: {{ totalTimeSpentOnCampaigns }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="col" v-if="
                    parameters.teamReportType === 'billable' &&
                    isBillableDataLoaded
                  ">
                    <div class="card border-0 shadow card-dashboard">
                      <div class="card-body">
                        <h6 class="card-subtitle mb-2 text-muted">
                          Spent (W Offered) (day)
                        </h6>
                        <h5 class="card-title">
                          Spent: {{ totalTimeSpentOnCampaigns2 }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="card" id="card-chart" v-if="!empty">
            <barChart :data="chartData" :key="barChartKey"></barChart>
          </div>
          <div class="card" id="card-chart" v-else>
            <h3 class="card-title">No Data to display</h3>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <button class="btn btn-outline-primary me-2" @click="csvExport(chart)">
            Download chart data
          </button>
        </div>
      </div>
      <div v-if="showTotalsModal" class="modal-overlay">
        <div class="modal-window">
          <div class="modal-header d-flex justify-content-between align-items-center p-3 border-bottom">
            <h6 class="mb-0">Totals</h6>
            <button type="button" class="btn-close" @click="showTotalsModal = false"></button>
          </div>
          <div class="modal-body p-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item" v-for="(value, key) in totals" :key="key" style="list-style: none">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </protected-pages-layout>
</template>

<script setup>
import Navbar from "../components/Navbar.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import ExportModule from "../components/ExportModule.vue";
import { storeToRefs } from "pinia";
import { periods, breakdowns, teamReportTypes } from "../assets/variables.js";
import { ref, onMounted, computed } from "vue";
import { useTeamReportStore } from "../stores/teamReport.js";

const teamReportStore = useTeamReportStore();

const {
  getTeams: teams,
  getTotal: total,
  getChart: chart,
  getParameters: parameters,
  getChartData: chartData,
  getBarChartKey: barChartKey,
  getEmpty: empty,
  getTotals: totals,
  getCampaignsForTeam: campaignsForTeam,
  isBillableDataLoaded,
} = storeToRefs(teamReportStore);

const { fetchTeams, getReport, calculateTotals, csvExport } = teamReportStore;

let pageReady = ref(false);
onMounted(async () => {
  await fetchTeams();
  await getReport();
  pageReady.value = true;
});

const totalManDaysInCampaigns = computed(() => {
  if (campaignsForTeam.length === 0 && teamReportStore.isBillableDataLoaded)
    return 0;
  return campaignsForTeam.value
    .reduce((acc, campaign) => acc + campaign.ManDaysUsed, 0)
    .toFixed(2);
});

const totalTimeSpentOnCampaigns = computed(() => {
  if (campaignsForTeam.length === 0 && teamReportStore.isBillableDataLoaded)
    return 0;
  return campaignsForTeam.value
    .filter((campaign) => campaign.ManDaysUsed > 0)
    .reduce((acc, campaign) => acc + campaign.TimeSpentOnCampaign, 0)
    .toFixed(2);
});

const totalTimeSpentOnCampaigns2 = computed(() => {
  if (campaignsForTeam.length === 0 && teamReportStore.isBillableDataLoaded)
    return 0;
  return campaignsForTeam.value
    .reduce((acc, campaign) => acc + campaign.TimeSpentOnCampaign, 0)
    .toFixed(2);
});

const totalAsDay = computed(() => {
  if (!total.value) return 0;
  let currTot = parseFloat(String(total.value).replace(/,/g, "")) || 0;
  return (currTot / 8).toFixed(2);
});

const showTotalsModal = ref(false);
const openTotalsModal = () => {
  calculateTotals();
  showTotalsModal.value = true;
};
</script>

<script>
import Navbar from "../components/Navbar.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import ExportModule from "../components/ExportModule.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "TeamReport",
  components: {
    navbar: Navbar,
    barChart,
    ExportModule,
  },
});
</script>

<style scoped>
.wrapper {
  width: clamp(
    867px,
    calc(100vw * 0.8465),
    2166px
  );
  aspect-ratio: 1219/811;
  margin: 0 auto;
  position: relative;
}

.card {
  margin-top: 30px;
}

.group-header {
  color: #6c757d !important;
  font-weight: bolder;
  text-decoration: none;
  margin: 0px 13px;
  list-style-type: none;
  cursor: pointer;
}

.group-header:after {
  content: "";
  display: block;
  /* margin: auto; */
  height: 3px;
  width: 0px;
  background: transparent;
  transition: width 0.2s ease;
}

.group-header:hover:after {
  width: 120px;
  background: #fe938c;
}

h2 {
  text-align: center;
}

.entry-detail {
  text-align: left;
}

.table th {
  border-top: none !important;
}

.table td {
  border-top: none !important;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-window {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
  width: 90%;
  max-width: 500px;
}
</style>
